module.exports = __webpack_public_path__ + "img/logo-old.75204a3b.png";